<cigna-modal
  [options]="{ class: 'cigna-modal-lg', backdrop: 'static' }"
  #drugSearchModal
>
  <cigna-modal-layout [close]="'Close'" class="modal-title">
    <div
      class="modal-title"
      *cignaModalLayoutTitle
      [attr.id]="drugSearchModal.labelledBy"
    ></div>
    <div *ngIf="drugSearchModal.isOpened">
      <cigna-search-box
        #searchBoxRef
        (getDrugList)="
          getDrugList($event, false);
          searchAlphabet = $event;
          showSearchInfo = searchBoxRef.searchedDrugName !== ''
        "
        (callToTypeaHead)="callToTypeaHead($event)"
        (reset)="searchAlphabet = ''; drugDataLoading = false"
        [typeaHead]="typeaHead$ | async"
        [otherInfo]="otherInfo$ | async"
        [consumerId]="consumerId"
      ></cigna-search-box>
    </div>

    <div *ngIf="drugDataLoading">
      <ng-container
        *cignaWaitToLoad="drugsList$; let list; errorState: showDrugError"
      >
        <cigna-drug-search-results-table
          (getTherapeuticDrugList)="getTherapeuticDrugList($event)"
          (getDrugList)="
            getDrugList($event, false);
            searchAlphabet = $event;
            showSearchInfo = false
          "
          [alphabet]="searchAlphabet"
          [showSearchInfo]="showSearchInfo"
          [selectedDrugList]="list"
          [otherInfo]="otherInfo$ | async"
          [consumerId]="consumerId"
          [loadedDataLength]="currentPage * 50"
          (loadMoreData)="getDrugList($event, true)"
          [isClassCodeClicked]="isTherapeuticCode"
        >
          ></cigna-drug-search-results-table
        >
      </ng-container>
    </div>
    <cigna-additional-drug-info
      [nonIFPPdf]="'pdfs.non_ifp' | translate"
      [isIfp]="indicator"
    ></cigna-additional-drug-info>
    <ng-template #showDrugError>
      <p class="rx-cnt-error">
        {{
          'drugNameSearch.error_messages.hcp.service_error.message' | translate
        }}
      </p>
    </ng-template>
  </cigna-modal-layout>
</cigna-modal>
